class TokenService {
    constructor() {
        this.refreshing = null
        // Refresh 1 minuto prima della scadenza
        this.refreshThreshold = 60
    }

    async refreshToken() {
        try {
            // Se c'è già un refresh in corso, aspetta quello
            if (this.refreshing) {
                return this.refreshing
            }

            // Avvia il refresh
            this.refreshing = this.$root.$api.post('/auth/refresh')
            const { data } = await this.refreshing

            // Salva il nuovo token
            localStorage.setItem('token', data.access_token)
            
            // Imposta il timer per il prossimo refresh
            this.scheduleRefresh(data.expires_in)

            return data
        } catch (error) {
            console.error('Errore durante il refresh del token:', error)
            // In caso di errore, reindirizza al login
            window.location.href = '/login'
        } finally {
            this.refreshing = null
        }
    }

    scheduleRefresh(expiresIn) {
        const refreshIn = (expiresIn - this.refreshThreshold) * 1000 // Converti in millisecondi
        if (refreshIn > 0) {
            setTimeout(() => this.refreshToken(), refreshIn)
        }
    }

    // Inizializza il refresh automatico
    initializeAutoRefresh(expiresIn) {
        if (expiresIn) {
            this.scheduleRefresh(expiresIn)
        }
    }
}

export default new TokenService()
